// extracted by mini-css-extract-plugin
export default {"toggleContainer":"Q--z","toggleBtn":"R--z","toggleLabel":"S--z","tooltipContainer":"T--z","tooltipWrapper":"U--z","tooltipContentTop":"V--z"};